import React from "react";

export const PRISMA_CLOUD_COMPUTE_URL = (
  <>
    For details please refer:{" "}
    <a
      href={
        "/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/42382671638931-Prisma-Cloud-Compute#h_01JJVG9ZWQXM9RX8567PRK760W"
      }
      target="_blank"
      rel="noopener noreferrer"
    >
      Documentation
    </a>
  </>
);

export const PRISMA_TWISTLOCK_URL = (
  <>
    For details please refer:{" "}
    <a
      href={
        "/api/jwt/zendesk/sso?return_to=https://support.armorcode.com/hc/en-us/articles/19452436164115-Prisma-Cloud-Twistlock-Deprecated#h_01JJVG9ZWQXM9RX8567PRK760W"
      }
      target="_blank"
      rel="noopener noreferrer"
    >
      Documentation
    </a>
  </>
);
